const ondcBenefits = {

    title: "Real Business Benefits from Day One",
    subtitle: "",
    steps: [
        {
            kpi: "6x",
            title: "Greater Reach",
            description: "Access to customers across multiple buyer apps multiplies your potential audience compared to single marketplace listings.",
        },
        {
            kpi: "30%",
            title: "Lower Costs",
            description: "ONDC's fee structure typically results in commission savings of approximately 30% compared to traditional e-commerce marketplaces.",
        },
        {
            kpi: "1mth",
            title: "Rapid Launch",
            description: "Our streamlined process gets most sellers fully operational on ONDC within just two weeks, compared to months of technical development.",
        },
        {
            kpi: "24/7",
            title: "Ongoing Support",
            description: "Continuous technical assistance and business optimisation advice ensures your ONDC presence constantly improves and evolves.",
        },        
    ]

}

export default ondcBenefits;